import { render, staticRenderFns } from "./SkillCategoryChart.vue?vue&type=template&id=8dff242e"
import script from "./SkillCategoryChart.vue?vue&type=script&lang=ts"
export * from "./SkillCategoryChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports